<template>
  <div class="page-compact">
    <crm-panel :title="'项目列表'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.projectListExport && auth.projectListExport.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>

      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <el-select
              v-model="searchForm.projectStatus"
              clearable
              @clear="clearSearch"
              placeholder="项目状态"
            >
              <el-option
                v-for="item in projectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <div class="select-data-picker">
              <el-select v-model="searchDateType" style="width: 160px">
                <el-option label="项目开始时间" value="start"></el-option>
                <el-option label="项目结束时间" value="end"></el-option>
                <el-option label="项目创建时间" value="create"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="searchTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchTypeValue"
              @clear="handleSearch"
              class="input-with-select"
              clearable
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option label="项目名称" value="name"></el-option>
                <el-option label="项目负责人" value="personCharge"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 列表 -->
      <el-table
        :data="crmProjectData && crmProjectData.results"
        height="100%"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          label="项目名称"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleProjectDetailShow(scope)">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="businessName"
          fixed="left"
          width="250"
          label="商机名称"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleBusinessDetailShow(scope)">{{
              scope.row.businessName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="code"
          align="center"
          label="项目编号"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="personCharge"
          align="center"
          width="150"
          label="项目负责人"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="startDate"
          align="center"
          label="项目开始时间"
        >
          <template slot-scope="scope">
            {{ scope.row.startDate | formatTimeYMD }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="endDate"
          align="center"
          label="项目结束时间"
        >
          <template slot-scope="scope">
            {{ scope.row.endDate | formatTimeYMD }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="status"
          align="center"
          label="项目状态"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="creator"
          align="center"
          label="创建人"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="gmtCreatedStr"
          align="center"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="linkDateStr"
          align="center"
          label="关联时间"
        >
        </el-table-column>
      </el-table>
      <!-- 合同列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next"
          :total="(crmProjectData && crmProjectData.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>
    <!-- 项目详情侧面板 -->
    <transition name="slide-fade">
      <div v-if="projectDetailVisible">
        <crm-project-detail
          :detailId="detailId"
          :projectId="projectId"
          :authList="projectProcessManageAuthorityDTO"
          @handleCloseDetail="handleCloseProjectDetail"
        >
        </crm-project-detail>
      </div>
    </transition>
    <!-- 商机详情侧面板 -->
    <busi-detail
      :nextButtonState="nextButtonState"
      v-if="businessDetailVisible"
      :detailId="businessId"
      :isShangJi="true"
      @handleCloseBusiDetail="handleCloseBusinessDetail"
    >
    </busi-detail>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import config from "~config";
import { newDownloadByUrl, formatTimeYMD } from "@/scripts/utils";
import AddProject from "~component/business/project/addProject.vue";
import crmProjectDetail from "~component/business/project/crmProjectDetail.vue";
import crmPanel from "@/components/base/crmPanel";
import crmButton from "@/components/base/crmButton";
import CrmCascader from "@/components/base/crmCascader";
import BusiDetail from "~component/business/busiopportunity/busiDetail";
import service from "@/services/api/project";

export default {
  components: {
    AddProject,
    crmProjectDetail,
    crmPanel,
    crmButton,
    CrmCascader,
    BusiDetail,
  },
  data() {
    return {
      loading: false,
      searchName: "",
      searchTime: null,
      // 时间类型
      searchDateType: "start",
      searchNameType: "name",
      // 搜索表单
      searchForm: {
        projectStatus: null,
        searchDateType: null,
        startDate: null,
        endDate: null,
        name: null,
        personCharge: null,
      },
      projectStatusList: [],
      searchTypeValue: null,
      searchFormList: [
        { key: 1, name: "项目名称", value: "projectName" },
        { key: 2, name: "客户名称", value: "customerName" },
        { key: 3, name: "sourceid", value: "projectSourceId" },
        { key: 4, name: "套餐名称", value: "projectPackageName" },
        { key: 5, name: "套餐编号", value: "projectPackageCode" },
        { key: 6, name: "业务员", value: "salesmanName" },
      ],
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      isExportDisabled: false,
      detailId: "",
      // PMO ID
      projectId: "",
      id: "",
      projectDetailVisible: false,
      businessDetailVisible: false,
      businessId: "",
      nextButtonState: false,
      // 详情权限
      projectProcessManageAuthorityDTO: [],
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      busiOpportunityDetail: "business/busiOpportunityDetail",
      crmProjectData: "project/crmProjectData",
      projectTeams: "project/projectTeams",
      userInfo: "authority/userInfo",
      businessAuth: "authority/businessAuth",
    }),
  },
  watch: {
    searchTime: {
      handler() {
        console.log(this.searchTime, "searchTime");
        if (!this.searchTime) {
          this.searchForm.startDate = "";
          this.searchForm.endDate = "";
          this.pagenation.pageNumber = 1;
          this.pagenation.pageSize = 20;
        }
        if (this.searchTime && this.searchTime.length > 0) {
          this.searchForm.startDate = this.searchTime[0];
          this.searchForm.endDate = this.searchTime[1];
          this.pagenation.pageNumber = 1;
          this.pagenation.pageSize = 20;
        }
        this.handleSearch();
      },
      deep: true,
    },
    searchDateType: {
      handler(newval, oldval) {
        if (this.searchTime && this.searchTime.length > 0) {
          this.searchForm.startDate = this.searchTime[0];
          this.searchForm.endDate = this.searchTime[1];
          this.pagenation.pageNumber = 1;
          this.pagenation.pageSize = 10;
          this.handleSearch();
        }
      },
    },
    "searchForm.projectStatus": {
      handler(newval, oldval) {
        this.pagenation.pageNumber = 1;
        this.pagenation.pageSize = 10;
        this.handleSearch();
      },
    },
    searchNameType: {
      handler(newval, oldval) {
        if (this.searchNameType === "name") {
          this.searchForm.personCharge = "";
        } else {
          this.searchForm.name = "";
        }
        this.searchTypeValue = "";
        this.pagenation.pageNumber = 1;
        this.handleSearch();
      },
    },
  },
  created() {
    this.getAuthority({ menuUrl: "/business/opportunity" });
    this.getProjectStatus();
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.searchDateType = this.$route.params.searchDateType
        ? this.$route.params.searchDateType
        : "start";
      this.searchTime = this.$route.params.searchTime
        ? this.$route.params.searchTime
        : [];
    } else {
      this.handleSearch();
    }
  },
  filters: {
    formatTimeYMD,
  },
  methods: {
    ...mapActions({
      getCrmProjectList: "project/getCrmProjectList",
      getAuthority: "authority/getAuthority",
      getBusiOpprtunityDetail: "business/getBusiOpprtunityDetail",
    }),
    getProjectStatus() {
      service.queryProjectStatus().then((res) => {
        this.projectStatusList = res.data.data;
      });
    },
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      this.handleSearch();
      const params = {
        ...this.searchForm,
      };
      const url = `${config.api || ""}/api/crmProjectManagement/export`;
      newDownloadByUrl(url, "get", params).finally(() => {
        this.isExportDisabled = false;
        this.notify.close();
      });
    },
    // 合同详情
    async handleProjectDetailShow(scope) {
      if (!this.auth.projectDetail.toggleStatus)
        return this.$message.error("暂无查看详情权限！");
      const limit = await service.queryProjectDetailAuth({
        projectId: scope.row.projectId,
      });
      if (limit.data.data) {
        await service
          .listProjectAuth({ projectId: scope.row.projectId })
          .then((res) => {
            if (res.data.auth) {
              this.detailId = scope.row.id;
              this.projectId = scope.row.projectId;
              this.projectDetailVisible = true;
              this.projectProcessManageAuthorityDTO =
                res.data?.projectProcessManageAuthorityDTO?.tabs || [];
            } else {
              this.$message.error(
                "无法查看该项目详情，请联系项目管理人员在PMO系统中维护"
              );
            }
          })
          .catch(() => {
            this.$message.error("无法查看该项目详情，请联系项目管理人员在PMO系统中维护");
          });
      } else {
        this.$message.error("无法查看该项目详情，请联系项目管理人员在PMO系统中维护");
      }
    },
    handleCloseProjectDetail(isRefresh) {
      this.projectDetailVisible = false;
      if (isRefresh) {
        this.handleSearch();
      }
    },
    // 搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;

      if (this.searchNameType) {
        this.searchForm[this.searchNameType] = this.searchTypeValue;
      }

      // dataType 必须在 startTime、endTime 有值的情况下存在
      if (this.searchTime && this.searchTime.length > 0) {
        this.searchForm.startDate = this.searchTime[0];
        this.searchForm.endDate = this.searchTime[1];
        this.searchForm.searchDateType = this.searchDateType;
      } else {
        this.searchForm.searchDateType = "start";
      }

      this.handleGetProjectList();
    },
    // 根据条件刷新项目列表
    handleGetProjectList() {
      this.loading = true;
      this.getCrmProjectList({
        ...this.pagenation,
        ...this.searchForm,
        // $_priority: 10,
      })
        .then(() => {
          if (
            this.crmProjectData.results.length === 0 &&
            this.crmProjectData.pageNumber !== 1
          ) {
            // this.pagenation.pageNumber = 1;
            this.handleGetProjectList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;

      this.handleGetProjectList();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetProjectList();
    },
    handleRefreshProject() {
      this.handleGetProjectList();
    },
    // 商机详情
    async handleBusinessDetailShow(scope) {
      if (this.businessAuth?.bizDetailTab?.toggleStatus) {
        // 判断是否有权限
        this.getBusiOpprtunityDetail({ id: scope.row.businessId })
          .then((res) => {
            this.businessId = scope.row.businessId;
            this.businessDetailVisible = true;
            this.nextButtonState = true;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.error("无操作权限!");
      }
    },
    handleCloseBusinessDetail(isRefresh) {
      this.businessId = "";
      this.nextButtonState = false;
      this.businessDetailVisible = false;
      if (isRefresh) {
        this.handleSearch();
      }
    },
    clearSearch() {
      this.pagenation.pageNumber = 1;
      this.pagenation.pageSize = 10;
      this.handleSearch();
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/const.less";

.page-compact {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }
}
</style>
